import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import { useTransactionData } from "@/context/transactionContext";
import { getTransactionData } from "@/services/api";
import CircularLoader from "@/components/atoms/CircularLoader";
import DepositStatus from "./DepositStatus";
import DepositStatus1xbet from "./DepositStatus1xbet";

function DepositStatusIndex() {
  const { id, token } = useParams();
  const { transactionData, setTransactionData } = useTransactionData();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const hasData = !!transactionData?.id;
  const canFetch = !!id && !!token;
  const needsHydration = !hasData && canFetch;

  useEffect(() => {
    const fetchMissingData = async () => {
      if (needsHydration && !isLoading) {
        try {
          setIsLoading(true);
          const res = await getTransactionData(id, token);
          setTransactionData(res.data);
        } catch (err) {
          setError("No se pudo cargar la transacción");
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchMissingData();
  }, [needsHydration, id, token, setTransactionData, isLoading]);

  if (isLoading || (needsHydration && !error)) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-white sm:bg-gray-900">
        <CircularLoader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen text-red-500">
        {error}
      </div>
    );
  }

  return <FinalView />;
}

function FinalView() {
  const { is1xbet } = useMerchantTheme();
  return is1xbet ? <DepositStatus1xbet /> : <DepositStatus />;
}

export default DepositStatusIndex;
